window.addEventListener("load", function(event) {
    const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
    const vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
    var navbar = document.getElementById("navigation"); 
    var header = document.getElementById("header");

    
    header.style.marginTop = navbar.offsetHeight + "px";
    header.style.height = vh - navbar.offsetHeight + "px";
});